import { ptBR } from "date-fns/locale";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material";

import {
  AlertComponent,
  ConfirmationDialogComponent,
} from "./shared/components";
import { AppRoutes } from "./routes";
import { ThemesProvider } from "./shared/contexts";

ClassNameGenerator.configure((componentName) => `${componentName}`);

export const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBR}>
      <ThemesProvider>
        <BrowserRouter basename="assinatura-eletronica">
          <AppRoutes />
        </BrowserRouter>

        <AlertComponent />
        <ConfirmationDialogComponent />
      </ThemesProvider>
    </LocalizationProvider>
  );
};
